/**
 * KBG v2 — FAQ: keyboard toggle for <details>/<summary>
 * Native Enter can fail when summary is restyled, and base-ada.js
 * synthesizes a second click that immediately closes the item.
 */
(function () {
  'use strict';

  if (window.__kbgV2FaqInit >= 1) return;
  window.__kbgV2FaqInit = 1;

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function syncExpanded(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function bindItem(details) {
    if (!details || details.dataset.kbgFaqBound === 'true') return;
    details.dataset.kbgFaqBound = 'true';

    var summary = details.querySelector('summary');
    if (!summary) return;

    syncExpanded(details);
    details.addEventListener('toggle', function () {
      syncExpanded(details);
    });

    summary.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.repeat) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        details.open = !details.open;
        syncExpanded(details);
      },
      true
    );
  }

  function init(root) {
    qsa(root || document, '.kbg-v2-section.faq details').forEach(bindItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
